import { X, AlertCircle, CheckCircle, Info, XCircle } from 'lucide-react'

interface AlertModalProps {
  isOpen: boolean
  onClose: () => void
  title: string
  message: string
  variant?: 'success' | 'error' | 'warning' | 'info'
  buttonText?: string
}

export function AlertModal({
  isOpen,
  onClose,
  title,
  message,
  variant = 'info',
  buttonText = 'Fechar',
}: AlertModalProps) {
  if (!isOpen) return null

  const variantStyles = {
    success: {
      icon: 'bg-green-100 text-green-600',
      IconComponent: CheckCircle,
      button: 'bg-green-600 hover:bg-green-700',
    },
    error: {
      icon: 'bg-red-100 text-red-600',
      IconComponent: XCircle,
      button: 'bg-red-600 hover:bg-red-700',
    },
    warning: {
      icon: 'bg-amber-100 text-amber-600',
      IconComponent: AlertCircle,
      button: 'bg-amber-600 hover:bg-amber-700',
    },
    info: {
      icon: 'bg-teal-100 text-teal-600',
      IconComponent: Info,
      button: 'bg-teal-600 hover:bg-teal-700',
    },
  }

  const styles = variantStyles[variant]
  const IconComponent = styles.IconComponent

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />
      <div className="relative bg-white rounded-xl shadow-xl w-full max-w-md mx-4">
        <div className="flex items-center justify-between p-4 border-b border-gray-200">
          <h3 className="text-lg font-semibold">{title}</h3>
          <button onClick={onClose} className="p-2 text-gray-400 hover:text-gray-600 rounded-lg">
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="p-6">
          <div className="flex items-start gap-4">
            <div className={`w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 ${styles.icon}`}>
              <IconComponent className="w-5 h-5" />
            </div>
            <p className="text-gray-600 pt-2">{message}</p>
          </div>
        </div>

        <div className="p-4 border-t border-gray-100 flex justify-end">
          <button
            onClick={onClose}
            className={`px-4 py-2 text-white rounded-lg transition-colors ${styles.button}`}
          >
            {buttonText}
          </button>
        </div>
      </div>
    </div>
  )
}
